export interface TipBox {
  left: number
  right: number
  top: number
  bottom: number
}

export interface TipPlacement {
  /** Viewport x of the bubble's left edge, in px. */
  left: number
  /** Viewport y of the bubble's top edge, in px. */
  top: number
  /** True when the bubble opens above the trigger. */
  above: boolean
}

const TIP_MARGIN = 8

/** Keeps a bubble of the given size inside the viewport, flipping above only when below does not fit and above has more room. */
export function placeHelpTip(
  trigger: TipBox,
  bubble: { width: number; height: number },
  viewport: { width: number; height: number },
  align: 'start' | 'end',
  gap = 4,
  margin = TIP_MARGIN,
): TipPlacement {
  const wanted = align === 'end' ? trigger.right - bubble.width : trigger.left
  const max = viewport.width - margin - bubble.width
  const left = max < margin ? margin : Math.min(Math.max(wanted, margin), max)

  const below = viewport.height - trigger.bottom - gap - margin
  const over = trigger.top - gap - margin
  const above = bubble.height > below && over > below
  const top = above ? trigger.top - gap - bubble.height : trigger.bottom + gap

  return { left, top, above }
}

export function samePlacement(a: TipPlacement | null, b: TipPlacement): boolean {
  return !!a && a.above === b.above && Math.abs(a.left - b.left) < 0.5 && Math.abs(a.top - b.top) < 0.5
}
